<template>
    <Modal v-if="visible" :title="title">
        <div class="modal-warning">
            <div class="modal-warning-content">
                <slot />
            </div>

            <div class="modal-warning-footer">
                <ButtonSecondary :onClick="() => onSelect(false)">
                    {{ onDenyLabel }}
                </ButtonSecondary>

                <ButtonPrimary :onClick="() => onSelect(true)">
                    {{ onAcceptLabel }}
                </ButtonPrimary>
            </div>
        </div>
    </Modal>
</template>
<script lang="ts">
    import { defineComponent, PropType } from 'vue';
    import { t } from '@shared/helpers/translation';
    import Modal from '@ui/components/Modal/Modal.vue';
    import ButtonPrimary from '@ui/components/Button/ButtonPrimary.vue';
    import ButtonSecondary from '@ui/components/Button/ButtonSecondary.vue';

    export default defineComponent({
        name: 'WarningModal',
        components: { Modal, ButtonPrimary, ButtonSecondary },
        props: {
            visible: { type: Boolean, required: true },
            title: {
                type: String,
                required: false,
                default: () =>
                    t({
                        key: 'shared.are_you_sure',
                    }),
            },
            onSelect: {
                type: Function as PropType<(state: boolean) => void>,
                required: true,
            },
            onAcceptLabel: {
                type: String,
                required: false,
                default: () => t({ key: 'shared.yes_add_to_booking' }),
            },
            onDenyLabel: {
                type: String,
                required: false,
                default: () => t({ key: 'shared.no_thank_you' }),
            },
        },
    });
</script>
<style lang="scss" scoped>
    @use '@/styles/import.scss' as *;

    .modal-warning {
        @include flex(column);
        gap: var(--spacing-32);

        &-footer {
            @include flex(column-reverse, center);
            place-items: stretch;
            gap: var(--spacing-12);
            width: 100%;

            @include up(sm) {
                flex-direction: row;
            }

            & > button {
                width: 100%;

                .label {
                    text-align: center;
                }
            }
        }
    }
</style>
